import axios from "axios";

export default axios.create({
  baseURL: "https://live-posts.3news.com",
});
